var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 21a3.005 3.005 0 0 1-1.516 2.61l-.004 3.206a6.003 6.003 0 0 0 .015-11.628l-.004 3.207A3.005 3.005 0 0 1 27 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.31 20.996c0 5.223-3.235 9.691-7.81 11.511v-3.314a9.393 9.393 0 0 0 4.81-8.197 9.393 9.393 0 0 0-4.81-8.198V9.485c4.575 1.82 7.81 6.287 7.81 11.51zM11.546 13.5l6.29-4.193a3 3 0 0 1 4.664 2.496v18.394a3 3 0 0 1-4.664 2.496l-6.29-4.193H9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h2.546zM9 16.5v9h3.454l7.046 4.697V11.803L12.454 16.5H9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.031928b40d50360bb327c1a0850ca4c2.svg";
export { ForwardRef as ReactComponent };